import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowDown } from 'react-icons/md';

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(1);
    
    const accordionData = [
        {
            id: 1,
            title: 'How does Privix.AI ensure data privacy and security?',
            desc: 'Privix.AI operates entirely within your infrastructure. We use local embeddings and open-source LLMs that run on your servers, ensuring your sensitive data never leaves your premises. All processing happens behind your firewall with military-grade security protocols.',
        },
        {
            id: 2,
            title: 'What infrastructure is needed to run Privix.AI?',
            desc: `For the Enterprise Suite, you'll need servers capable of running our LLMs and processing your data volume. Don't have the infrastructure? Our Managed Solution provides a secure, dedicated environment while maintaining strict data privacy standards. We can discuss specific requirements during consultation.`,
        },
        {
            id: 3,
            title: 'How accurate is the document querying system?',
            desc: 'Our RAG (Retrieval-Augmented Generation) technology ensures high accuracy by combining the power of large language models with precise document retrieval. The system provides source references for its answers, allowing for easy verification. During the trial period, you can test it with your own documents to see the accuracy firsthand.',
        },
        {
            id: 4,
            title: 'Can Privix.AI handle multiple document formats and databases?',
            desc: 'Yes, Privix.AI supports a wide range of document formats including PDFs, Word documents, spreadsheets, and various database types. Our natural language to SQL feature works with major database systems, and our document processing can handle structured and unstructured data.',
        },
        {
            id: 5,
            title: 'What kind of support and maintenance is included?',
            desc: 'All plans include technical support. Enterprise customers receive 24/7 priority support, regular updates, and system optimization. We also provide comprehensive documentation, training sessions, and dedicated account management for enterprise deployments.',
        },
        {
            id: 6,
            title: 'How long does it take to implement Privix.AI?',
            desc: 'Implementation time varies based on your setup. The Test Drive can be running within hours. For Enterprise deployments, we typically complete setup within 2-4 weeks, including integration, security configurations, and team training. Our managed solution can be deployed more quickly, usually within 1-2 weeks.',
        },
    ];

    return (
        <div className="container relative md:mt-24 mt-16">
            <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 items-center md:gap-[30px]">
                <div className="lg:col-span-4 md:mb-0 mb-8">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">
                        Have Questions? <br/> 
                        <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">
                            We've Got Answers
                        </span>
                    </h3>

                    <p className="text-slate-400 max-w-xl mx-auto mb-6">
                        Experience the power of secure AI with our no-risk trial. Process your documents and data locally while maintaining complete control over your sensitive information.
                    </p>

                    <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-transparent hover:bg-amber-400 border-gray-100 dark:border-gray-800 hover:border-amber-400 dark:hover:border-amber-400 text-slate-900 dark:text-white hover:text-white rounded-md">
                        Contact Us
                    </Link>
                </div>

                <div className="lg:col-span-8 md:mt-0 mt-8">
                    {accordionData.map((item, index) => (
                        <div className="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden mt-4" key={index}>
                            <h2 className="text-base font-semibold">
                                <button 
                                    type="button" 
                                    onClick={() => setActiveIndex(item.id)} 
                                    className={`${activeIndex === item.id ? "bg-gray-50 dark:bg-slate-800 text-amber-400" : ""} flex justify-between items-center p-5 w-full font-medium text-start`}
                                >
                                    <span>{item.title}</span>
                                    <MdKeyboardArrowDown className={`${activeIndex === item.id ? "rotate-180" : ""} w-4 h-4 shrink-0`}/>
                                </button>
                            </h2>
                            <div className={activeIndex === item.id ? "" : "hidden"}>
                                <div className="p-5">
                                    <p className="text-slate-400 dark:text-gray-400">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Faq;